import React from 'react'

import "./footer.css"
import footer_logo from '../assets/Landing_page/footer_logo.png';
import contact_boy from "../assets/Landing_page/contact_boy.png"
import { Link } from 'react-router-dom';


const FooterOther = () => {
    return (
        <div className='mt-[200px]'>
            <div className='section_3_container   relative'>
                <div className='cross_image flex justify-center items-center flex-col pt-[20px]'>
                    <div className='w-full xl:w-[80%]  flex justify-around items-center flex-wrap text-white_color text-[14px]'>

                        <div className='footer_left w-[90%] xl:w-[60%] flex flex-col '>
                            <div>
                                <img src={footer_logo} alt="footer logo" />
                            </div>
                            <div className='mt-[20px] w-[95%] xl:w-[70%]'>
                                <p>It is an English literacy enhancement platform developed and managed by Orden Technical Services Pvt. Ltd, a leader in creating innovative tech-driven solutions for education sector.</p>
                            </div>

                            {/* <div className='mt-[20px]'>
                                <span>Terms and Condtions  </span>
                                <span> | </span>
                                <span>Privacy Policy</span>
                            </div> */}

                        </div>

                        <div className='w-[90%] xl:w-[30%] flex justify-between'>

                            {/* <div className='useful_links_1 w-[20%]'>
                                <div className=''>
                                    <p className='text-[16px] font-semibold my-[10px]'>Useful Links</p>
                                </div>
                                <ul className='footer_list'>
                                    <li>Login</li>
                                    <li>Menu 1</li>
                                    <li>Menu 2</li>
                                    <li>Menu 3</li>

                                </ul>
                            </div> */}


                            {/* <div className='useful_links_1 w-[20%]'>
                                <div className=''>
                                    <p className='text-[16px] font-semibold my-[10px]'>Useful Links</p>
                                </div>
                                <ul className='footer_list'>
                                    <li>Login</li>
                                    <li>Menu 1</li>
                                    <li>Menu 2</li>
                                    <li>Menu 3</li>

                                </ul>
                            </div> */}


                            <div className='useful_links_1 w-full xl:w-[70%]'>
                                <div className='border-white border-b-[1px] '>
                                    <p className='text-[16px] font-semibold my-[10px]'>
                                        Support</p>
                                </div>
                                <div className='flex gap-[20px]'>
                                    <ul className='footer_list'>
                                        <Link to="/terms-and-conditions">
                                            <li className='cursor-pointer'>Terms and Condtions </li>
                                        </Link>
                                        <Link to="/privacy-policy">
                                            <li className='cursor-pointer'>Privacy Policy</li>
                                        </Link>



                                    </ul>

                                    <ul className='footer_list'>
                                        <Link to="/about-us">
                                            <li className='cursor-pointer'>About</li>
                                        </Link>
                                        <Link to="/contact-us">
                                            <li className='cursor-pointer'>Contact Us</li>
                                        </Link>
                                    </ul>
                                </div>
                            </div>

                        </div>
                    </div>




                    <div className='w-full mt-[10px] text-white_color'>

                        <hr className='w-full h-[1px] bg-input_border' />
                        <div className='flex justify-center items-center mt-[10px] xl:mt-[20px] mb-[10px] xl:mb-[0px] '>
                            <p className='text-[10px]'>
                                Copyright ©2025 & All Rights Reserved: Orden Technical Services Private Limited
                            </p>
                        </div>
                    </div>
                </div>

                {/* footer top content start  */}
                <div className='w-full '>
                    <div className='absolute top-[-200px]    footer_top_image'>

                        <div className='flex justify-center items-center min-h-[200px] relative'>
                            <div className='w-full 2xl:w-[70%] flex flex-wrap xl:flex-nowrap text-white_color gap-8'>
                                <div className='w-full xl:w-[60%] text-center'>
                                    <p className='mt-[15px] mx-[5px]'>
                                        Subscribe to LexiLearn, get expert onboarding, ensure data privacy, implement in classes, and receive ongoing support for smooth integration.
                                    </p>
                                </div>
                                <div className='flex justify-center w-full xl:w-auto'>
                                    <a href="/know-the-process">
                                        <button className='button_white font-semibold'>Know the process</button>
                                    </a>
                                </div>
                            </div>

                        </div>

                        {/* boy image start  */}
                        {/* <div className=' absolute top-[-400px] right-[0px]  2xl:right-[180px] -z-10'>
                            <img className='w-full' src={contact_boy} alt="contact boy image" />
                        </div> */}
                    </div>

                </div>
                {/* footer top content end */}


            </div>
        </div>
    )
}

export default FooterOther